import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import {EB_REST_URI, HOST_URI} from "./constants";
import { getEnv } from "./env";

export const BASE_API: AxiosRequestConfig = {
    baseURL: HOST_URI,
    ...(getEnv().RUNNING_ON_NODE ? { withCredentials: true } : {}),
    timeout: 60000,
    headers: {
        "Content-Type": "application/json",
    },
};


export interface EngagebayResponse<T = any, D = any> extends AxiosResponse<T, D> {
    customProperty?: string;
}

export const baseReqService = axios;
if (getEnv().RUNNING_ON_NODE)
    baseReqService.defaults.withCredentials = true;

// Base API for all requests, do not validate authentication errors
const baseApi = baseReqService.create({...BASE_API});

// Base API for all requests, do not validate authentication errors
const engagebayBaseAPI = baseApi;

export default engagebayBaseAPI;
